// extracted by mini-css-extract-plugin
export default {"container":"EmptyCard_container__x92-t"};